import { useRef } from "react";
import { EventFeedbackQuestionForm } from "./data/EventFeedbackQuestionForm.Data";
import Buttons from "../../components/ui/button/Buttons";
import FormCreator from "../../components/forms/FormCreator";
import DataLoader from "../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import { Suspense, useState } from "react";
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import { paginationObj } from '../../utils/Constants'
import { EventFeedbackQuestionTableConfig } from "./data/EventFeedbackQuestionTableConfig";
import { useGetFeedbackQuestionEventDetailListMutation, useLazyGetAllFeedbackAnswerListByEventIdQuery } from "../../app/services/EventManagement/EventFeedBackQuestion/EventFeedbackQuestionApi";
import { useEffect } from "react";
import { saveAs } from 'file-saver';
import { encryptAES } from "../../services/CryptoService";
import SwalAlert from "../../services/swalService/SwalService";

const EventFeedbackQuestionList = () => {
    const eventfeedbackQuestionRef = useRef();
    const molGridRef = useRef();
    const [dataSource, setDataSource] = useState();
    const [pagination, setPagination] = useState({
        ...paginationObj,
        SearchText: "",
    });
    const { confirm, success, error } = SwalAlert()
    const [getFeedbackQuestionList, { isLoading: feedbackQuestionListLoading, data: FeedbackQuestionListData, isSuccess: feedbackQuestionListIsSuccess }] = useGetFeedbackQuestionEventDetailListMutation();
    const [getfeedbackQuestionByEventId, { isSuccess: getfeedbackQuestionByEventIdIsSuccess, isLoading: getfeedbackQuestionByEventIdIsLoading, data: getfeedbackQuestionByEventIdData }] = useLazyGetAllFeedbackAnswerListByEventIdQuery();

    // useEffects

    useEffect(() => {
        if (!getfeedbackQuestionByEventIdIsLoading && getfeedbackQuestionByEventIdIsSuccess && getfeedbackQuestionByEventIdData) {
        }
    }, [getfeedbackQuestionByEventIdIsLoading, getfeedbackQuestionByEventIdIsSuccess, getfeedbackQuestionByEventIdData]);

    useEffect(() => {
        if (!feedbackQuestionListLoading && FeedbackQuestionListData && feedbackQuestionListIsSuccess) {
            setDataSource(FeedbackQuestionListData.itemList)
            setPagination(prev => {
                return { ...prev, totalCount: FeedbackQuestionListData.totalCount }
            });
        }
    }, [feedbackQuestionListLoading, FeedbackQuestionListData, feedbackQuestionListIsSuccess]);

    useEffect(() => {
        getFeedbackQuestionListData(pagination);
    }, []);

    const getFeedbackQuestionListData = (data) => {
        getFeedbackQuestionList(data);
    }
    const handlePageChange = (page) => {
        const { pageNumber, pageSize } = page;
        getFeedbackQuestionList({ ...pagination, pageSize: pageSize, pageNo: pageNumber })
    };
    const searchClick = () => {
        let formData = eventfeedbackQuestionRef?.current?.getFormData();
        let request = {
            ...paginationObj,
            SearchText: formData?.eventName || null,
        }
        setPagination(prev => { return { ...prev, ...request } });
        getFeedbackQuestionList(request);
    };

    const handleDownload = async (dataa) => {
        if (dataa?.booking === "0") {
            error("Booking is not available")
        }
        else {
            try {
                const id = encryptAES(dataa?.eventId);
                const response = await getfeedbackQuestionByEventId(
                    {
                        eventId: id,
                    }
                );
                if (response && response.data) {
                    const { fileData, fileName } = response.data;
                    const blob = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    saveAs(blob, fileName || 'download.xlsx');
                }
            } catch (error) {
                console.error('Error downloading the file:', error);
            }
        }
    }

    const actionHandler = {
        Download: handleDownload,
    };
    return (
        <>
            <div>
                <div className="membership-application">
                    <div className="form-card">
                        <Suspense fallback={<DataLoader />}>
                            <div className="">
                                <FormCreator
                                    config={EventFeedbackQuestionForm}
                                    ref={eventfeedbackQuestionRef}
                                    key={false}
                                />
                                <div className="col-lg-12 btn-sec mt-2">
                                    <Buttons
                                        onClick={searchClick}
                                        buttonText={"Search"}
                                        buttonTypeClassName="theme-btn btn mt-auto"
                                        isLoading={false}
                                    />
                                </div>
                            </div>
                        </Suspense>
                        <div>
                            <h5>Total Count : {pagination.totalCount}</h5>
                        </div>
                        <div className="table-100 mt-4">
                            <FinalMolGrid
                                ref={molGridRef}
                                configuration={EventFeedbackQuestionTableConfig}
                                dataSource={dataSource}
                                isLoading={feedbackQuestionListLoading}
                                allowPagination={true}
                                pagination={pagination}
                                onActionChange={actionHandler}
                                onPageChange={handlePageChange}

                            />
                        </div>
                    </div>
                </div>
            </div>
        </>)
}
export default EventFeedbackQuestionList;